import { render, staticRenderFns } from "./project_redirect_modal.vue.js?vue&type=template&id=fc4a986e&vue3!=!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./project_redirect_modal.vue?vue&type=template&id=fc4a986e&vue3"
import script from "./project_redirect_modal.vue.js?vue&type=script&lang=js&vue3!=!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./project_redirect_modal.vue?vue&type=script&lang=js&vue3"
export * from "./project_redirect_modal.vue.js?vue&type=script&lang=js&vue3!=!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./project_redirect_modal.vue?vue&type=script&lang=js&vue3"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports